import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import Sanitize      from '@utils/sanitize';

// -------------------------------------------------------

const Tooltip = ({children}) => children || null;
const OverlayTrigger = ({children}) => children || null;

class DraftContentsAfterResive extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      show: false,
      is_direct: false,
    };
  }
  // -------------------------------------------------------
  
  toggleShow(ng_count) {
    let flg = (this.state.show == true) ? false : true;
    this.setState({ show: flg });
  }
  // -------------------------------------------------------
  
  toggleDirect(ng_count) {
    let flg = (this.state.is_direct == true) ? false : true;
    this.setState({ is_direct: flg });
  }
  // -------------------------------------------------------
  
  render() {
    let contents = this.props.contents;
    let detail   = this.props.detail;
    let table    = this.props.table;
    
    if( detail.is_guest === 1 ) return null;
    
    let logs = [];
    detail.draft_logs.map((d) => {
      if( table == 'draft_caption' && d.mode == 1 ) return;
      if( table == 'draft_media' && d.mode == 0 ) return;
      
      if( d.contents_id != contents.contents_id ) return;
      if( table == 'draft_media' && d.media_id != contents.id ) return;
      
      logs.push(d);
    });
    if( logs.length == 0 ) return null;
    
    let ng_class = '';
    
    return (
      <div className="draft-contents-logs">
        <div className="draft-contents-logs-items">
          <div className={'history-button '+ ng_class} onClick={this.toggleShow.bind(this)}>
            <i className="material-icons">timeline</i>
            { (logs.length > 0) && <span>{(this.state.show == true) ? '確認履歴を閉じる' : '確認履歴を表示' }</span> }
          </div>
        </div>
        
        { (this.state.show == true) &&
          <ul className="draft-log-messages">
            { logs.map((d, key) => {
              
              // キャプション
              let msg = null;
              if( d.msg_diff != undefined ){
                msg = (
                  <div className="msg history">
                    { d.msg_diff.map((m, mkey) => {
                      try {
                        let _tag = Sanitize.nl2br(m[1]);

                        if( m[0] ==  0 ) return <span key={mkey} dangerouslySetInnerHTML={{ __html: _tag }} />;
                        if( m[0] ==  1 ) return <span key={mkey} className="plus" dangerouslySetInnerHTML={{ __html: _tag }} />;
                        if( m[0] == -1 ) return <span key={mkey} className="minus" dangerouslySetInnerHTML={{ __html: _tag }} />;
                      } catch(e) {console.log(e)}

                      return null;
                    })}
                  </div>
                );
              } else {
                try { if( d.revise_message != undefined && d.revise_message != null ) msg = Sanitize.nl2br(d.revise_message); } catch(e) {}
              }

              try {
                if( this.state.is_direct == true ) msg = <div className="msg history" dangerouslySetInnerHTML={{ __html: Sanitize.nl2br(d.revise_message) }} />;
              } catch(e) {}
              
              return (
                <li key={key}>
                  { (key > 0) && <p className="history-top"><i className="material-icons">arrow_upward</i></p> }
                  
                  <div className="name-box">
                    { (d.user_id == null)
                      ? <p className="name">{(logs.length - key)}. 共有アカウントから送信</p>
                      : <p className="name">{(logs.length - key)}. {d.name}<span>({d.email})</span></p>
                    }
                    <p className="date">{Utils.setDate(d.register_date, 'YYYY/M/D HH:mm')}</p>
                  </div>
                  
                  { (d.is_approval == null) && <p className="approval-none">●未設定</p> }
                  { (d.is_approval == 1) && <p className="approval-ok">●内容OK</p> }
                  { (d.is_approval == 0) && <p className="approval-ng">●修正依頼</p> }
                  
                  { (d.is_approval == null && d.msg_diff == undefined && msg != null) && <div className="msg" dangerouslySetInnerHTML={{ __html: msg }} /> }
                  { (d.is_approval == 0 && d.msg_diff == undefined) && <div className="msg" dangerouslySetInnerHTML={{ __html: msg }} /> }
                  { (d.is_approval == 0 && d.msg_diff != undefined) && msg }
                  
                  { (d.is_approval == 0) && <p className="direct-btn" onClick={this.toggleDirect.bind(this)}>{ (this.state.is_direct == true) ? '[差分データ表示]' : '[元データ表示]' }</p> }
                </li>
              );
            })}
          </ul>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftContentsAfterResive;